import localConfig from 'mode-shared/configs/config';
import { QueryKeys } from 'mode-shared/constants/queryKeys';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';

const fetcher = async () => {
  try {
    const { data: apy } = await axios.get<void, AxiosResponse<string, string>>(
      `${localConfig.apiUrl}/governance/rewards/apy`
    );

    return apy;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const useStakedAPY = (options = {}) => {
  return useQuery<string | undefined | null>({
    queryKey: [QueryKeys.STAKED_APY],
    queryFn: async () => {
      return fetcher();
    },
    staleTime: 10000,
    ...options,
  });
};
